import { z } from 'zod';
export const agentModeSchema = z.enum(['ASSIST', 'FAULTFIND', 'DESIGN', 'RESEARCH', 'SCRIBE']);
export const providerIdSchema = z.enum(['anthropic', 'ollama']);
export const sessionCreateSchema = z.object({
    mode: agentModeSchema.default('ASSIST'),
    /** Manual provider override for this session; default = the selector's choice. */
    provider: providerIdSchema.optional(),
    /** Per-session opt-in to send RESTRICTED notes to a cloud provider (scope §12.2). */
    allowRestricted: z.boolean().default(false),
    pinned: z.array(z.string()).default([]),
    title: z.string().max(200).optional(),
});
export const sessionMessageSchema = z.object({
    text: z.string().min(1).max(20_000),
    /** The note open in the editor, if any: it becomes context. */
    currentNoteId: z.string().optional(),
    /** Text the user has selected in the editor, if any. */
    selection: z.string().max(8000).optional(),
    /** Voice mode: the model adds a one-line "Spoken:" summary the client reads aloud (scope §14.2). */
    voice: z.boolean().optional(),
});
export const sessionPatchSchema = z.object({
    mode: agentModeSchema.optional(),
    provider: providerIdSchema.nullable().optional(),
    allowRestricted: z.boolean().optional(),
    pinned: z.array(z.string()).optional(),
    title: z.string().max(200).optional(),
});
export const toolInvokeSchema = z.object({
    name: z.string().min(1),
    input: z.record(z.unknown()).default({}),
});
export const proposalDecisionSchema = z.object({
    /** Patch proposals: indices of the hunks to apply (default all). */
    hunks: z.array(z.number().int().min(0)).optional(),
});
//# sourceMappingURL=agent.js.map